import React from 'react';

import { TbDots } from 'react-icons/tb';

import Button from 'components-new/button/button';

import type { PeriodJobInvitedFreelancer } from 'state/__generated__/tadaahAPI';

import DropdownMenu from 'components-new/dropdown-menu/dropdown-menu';

import type { DropdownMenuItemType } from 'components-new/dropdown-menu/dropdown-menu-item';

import { createLocale } from 'locales';

const localize = createLocale('organisationPeriodJobsLocales');
interface FreelancerOptionsTypes {
  freelancer: PeriodJobInvitedFreelancer;
}

const FreelancerOptions: React.FC<FreelancerOptionsTypes> = ({
  freelancer,
}) => {
  const dropdownMenuItems: DropdownMenuItemType[] = [
    {
      key: 'profile',
      label: localize('freelancerProfile'),
      onClick: () => {
        window.location.assign(
          `/organisation/freelancers/${freelancer.freelancer.freelancer_id}/profile/`,
        );
      },
      variant: 'normal',
    },
  ];

  return (
    <div className="w-10">
      <DropdownMenu
        autoplacement
        menuButton={() => (
          <Button
            label=""
            leftIconProps={{ icon: TbDots }}
            variant="transparent"
            className="hover:bg-transparent"
          />
        )}
        items={dropdownMenuItems}
        menuItemsClassName="z-50"
        position="right"
      />
    </div>
  );
};

export default FreelancerOptions;
